/*
 * window.requestAnimationFrame is added into Safari since 6.1
 * We should support all versions of Safari
 * ref.
 * window.requestAnimationFrame: https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 * Bing ads System requirements: http://help.si.bingads.microsoft.com/#apex/3/en/52033/-1
 */
import _ from 'underscore';

if (!window.requestAnimationFrame) {
  window.requestAnimationFrame = (callback) => {
    return _.defer(callback, Date.now());
  };
}

export default window.requestAnimationFrame;
